module.exports = __webpack_public_path__ + "static/media/8377C75B-14E7-4431-BF68-73BB94667294.bbffbc7d.png";